import React from "react";
import {
  formatInternationalPhoneNumber,
  normalizePriceString,
} from "../../helpers";
// @ts-ignore
import css from "./sectionObjectDownload.module.scss";
// import testImage from "../../../images/main-photo.png";

const sectionObjectDownloadDownload = ({
  data,
  planningState,
  dataAgent,
  objectPlanHandler,
  getDetails,
  slideIndex,
}) => {
  const agentFields = {
    name: dataAgent?.name,
    phone: dataAgent?.phone,
    email: dataAgent?.email,
  };

  return (
    <div className={css.sectionObjectDownload}>
      {data.apartments.map((el, index) => {
        const flatPreview = el.flat_plan_image?.links?.preview;
        const floorPreview = el.floor_plan_image?.links?.preview;
        const largeImageFlat = el.flat_plan_image?.links?.large;
        const largeImageFloor = el.floor_plan_image?.links?.large;

        return (
          <React.Fragment key={index}>
            <div className={css.sectionObjectDownload__content}>
              <div className={css.sectionObjectDownload__planning}>
                {largeImageFlat && (
                  <div
                    className={`${css.sectionObjectDownload__planLabel} ${
                      !floorPreview
                        ? css.sectionObjectDownload__planLabelCenter
                        : ""
                    }`}
                    style={{
                      backgroundImage: `url(${largeImageFlat})`,
                      backgroundSize: "contain",
                      maxWidth: "100%",
                      maxHeight: "100%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center center",
                    }}
                  ></div>
                )}
                <div className={css.sectionObjectDownload__planToggle}>
                  {/*{flatPreview && (*/}
                  {/*    <div className={`${css.sectionObjectDownload__planToggleItem}`}*/}
                  {/*         onClick={objectPlanHandler}*/}
                  {/*    >*/}
                  {/*        <div*/}
                  {/*            className={css.sectionObjectDownload__planToggleItemImage}*/}
                  {/*            id="flat_plan"*/}
                  {/*            style={{*/}
                  {/*                backgroundImage: `url(${flatPreview})`,*/}
                  {/*                backgroundSize: "cover",*/}
                  {/*                backgroundRepeat: "no-repeat",*/}
                  {/*                backgroundPosition: "center center",*/}
                  {/*            }}*/}
                  {/*        >*/}

                  {/*        </div>*/}
                  {/*    </div>*/}
                  {/*)}*/}

                  {floorPreview && (
                    <div
                      className={`${css.sectionObjectDownload__planToggleItem}`}
                      onClick={objectPlanHandler}
                    >
                      <div
                        className={
                          css.sectionObjectDownload__planToggleItemImage
                        }
                        id="flat_floor"
                        style={{
                          backgroundImage: `url(${floorPreview})`,
                          backgroundSize: "contain",
                          maxWidth: "100%",
                          maxHeight: "100%",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center center",
                        }}
                      ></div>
                    </div>
                  )}
                </div>
              </div>
              <div className={css.sectionObjectDownload__info}>
                <h4 className={css.sectionObjectDownload__title}>
                  {el.type.name}{" "}
                  {typeof el.total_area === "string"
                    ? normalizePriceString(el.total_area)
                    : el.total_area}{" "}
                  {el.total_area && "м²"}
                </h4>
                <div className={css.objectDetails}>
                  {getDetails(el).map((item, idx) => (
                    <div
                      key={idx}
                      className={
                        css.objectDetailRow +
                        (item?.isList ? " " + css.objectDetailRowList : "")
                      }
                    >
                      <span className={css.objectDetailLabel}>
                        <img
                          className={css.objectDetailLabelIcon}
                          src={item.icon}
                          alt={item.label}
                        />
                        <p className={css.objectDetailLabelText}>
                          {item.label}
                        </p>
                      </span>

                      {item.isList ? (
                        <ul className={css.objectDetailList}>
                          {item.value.map((listItem, i) => (
                            <li
                              className={`${css.objectDetailValue} ${
                                item.bold ? css.objectDetailValueBold : ""
                              }`}
                              key={i}
                            >
                              {listItem}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span
                          className={`${css.objectDetailValue} ${
                            item.bold ? css.objectDetailValueBold : ""
                          }`}
                        >
                          {item.value}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
                <div className={css.sliderInfo__footer}>
                  <div className={css.sliderInfo__footer}>
                    <ul className={css.sliderInfo__list}>
                      {dataAgent &&
                        Object.entries(agentFields).map(
                          ([key, value]) =>
                            value && (
                              <li
                                key={key}
                                className={`${css.sliderInfo__listItem} ${
                                  key === "name"
                                    ? css.sliderInfoValueBold
                                    : css.sliderInfoValue
                                }`}
                              >
                                {key === "phone"
                                  ? formatInternationalPhoneNumber(value, "RU")
                                  : value}
                              </li>
                            )
                        )}
                    </ul>
                    <span className={css.sliderInfo__countPage}>
                      {slideIndex}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default sectionObjectDownloadDownload;
